import { CurrencyPipe } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzCardModule } from 'ng-zorro-antd/card';

import { ProvisioningRoutingModule } from './provisioning-routing.module';
import { RecoverCandidateNumberComponent } from './recover-candidate-number/recover-candidate-number.component';
import { ProvisionComponent } from './provision/provision.component';
import { CertificatesComponent } from './certificates/certificates.component';

import { SharedModule } from '@shared';
import { ReactiveFormsModule } from '@angular/forms';
import { ExamNumberComponent } from './recover-candidate-number/exam-number/exam-number.component';
import { ShareModule } from './share/share.module';
import { AngularImageViewerModule } from '@clarivate/angular-image-viewer';

@NgModule({
  declarations: [
    ProvisionComponent,
    CertificatesComponent,
    RecoverCandidateNumberComponent,
    ExamNumberComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ProvisioningRoutingModule,
    SharedModule,
    NzCardModule,
    ShareModule,
    AngularImageViewerModule,
  ],
  providers: [
    CurrencyPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProvisioningModule { }
